import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect } from 'react';

export default function BackButton(props) {

  function onClickBackButton() {
    props.onClickBackButton();
  }


  return (
    <button className='back-button' onClick={()=> {onClickBackButton()}}>
      <Image className='arrow-right' alt='arrow right' src={require('./images/arrow-right.svg')} />
      <div className='text'>{props.text}</div>
    </button>
  );
}

